export default "/assets/images/welcome-mila-and-breathe-easy.5c0b74c10c40097b.png";